import { DASHBOARD_ASSETS, GET_DAILY_PNL, GET_DASHBOARD, GET_TOP_BOTS, RESET_ALL_PAGINATION } from "./types";
import { getDashboardUrl, getTopBotUrl, getDailyPnlUrl, assetsUrl } from "./const";
import network from "./network";

const getCachedPayload = (cacheKey, cacheDuration) => {
  const cachedData = localStorage.getItem(cacheKey);

  if (!cachedData) {
    return null;
  }

  try {
    const { payload, timestamp } = JSON.parse(cachedData);
    if (Date.now() - timestamp < cacheDuration) {
      return payload;
    }
  } catch (err) {
    localStorage.removeItem(cacheKey);
  }

  return null;
};

export const getDashboard = (exchangeId) => (dispatch, getState) => {
  network
    .get(
      getDashboardUrl,
      {
        exchange_id: exchangeId,
      },
      dispatch,
      getState
    )
    .then((res) => {
      const { active, reserved, available } = res.data;
      dispatch({
        type: GET_DASHBOARD,
        payload: { active, reserved, available },
      });
    });
};
export const getDashboardAssets = (exchangeId,type) => (dispatch, getState) => {
  const resetVersion = getState().settings.paperAccountResetVersion;
  const CACHE_KEY = `dashboard_assets_cache_${exchangeId}`;
  const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

  const cachedPayload = getCachedPayload(CACHE_KEY, CACHE_DURATION);
  if (cachedPayload) {
    dispatch({
      type: DASHBOARD_ASSETS,
      payload: cachedPayload,
    });
    return;
  }

  network
    .get(
      assetsUrl,
      {
        exchange_id: exchangeId
      },
      dispatch,
      getState
    )
    .then((res) => {
      if (getState().settings.paperAccountResetVersion !== resetVersion) return;
      //const { active, reserved, available } = res.data;
      const payload = res.data;
      localStorage.setItem(CACHE_KEY, JSON.stringify({ payload, timestamp: Date.now() }));
      dispatch({
        type: DASHBOARD_ASSETS,
        payload,
      });
    });
};

export const getTopBots = (timeFrame) => (dispatch, getState) => {
  network
    .get(
      getTopBotUrl,
      {
        time_frame: timeFrame,
      },
      dispatch,
      getState
    )
    .then((res) => {
      const { bots } = res.data;
      dispatch({
        type: GET_TOP_BOTS,
        payload: bots,
      });
    });
};

export const getDailyPnl = (exchange_id) => (dispatch, getState) => {
  const resetVersion = getState().settings.paperAccountResetVersion;
  const CACHE_KEY = `daily_pnl_cache_${exchange_id}`;
  const CACHE_DURATION = 4 * 60 * 60 * 1000; // 4 hours

  const cachedPayload = getCachedPayload(CACHE_KEY, CACHE_DURATION);
  if (cachedPayload) {
    dispatch({
      type: GET_DAILY_PNL,
      payload: cachedPayload,
    });
    return;
  }

  network
    .get(
      getDailyPnlUrl,
      {
        exchange_id,
      },
      dispatch,
      getState
    )
    .then((res) => {
      if (getState().settings.paperAccountResetVersion !== resetVersion) return;
      const { apy, pnl, chart_data, code } = res.data;
      if (code == 200) {
        const payload = { apy, pnl, chart_data };
        localStorage.setItem(CACHE_KEY, JSON.stringify({ payload, timestamp: Date.now() }));
        dispatch({
          type: GET_DAILY_PNL,
          payload,
        });
      }
    })
    .catch(() => {});
};
export const resetPagination = () => (dispatch, getState) => {
  dispatch({
    type: RESET_ALL_PAGINATION
  });
};
